import { API } from '@apis'
import { AdminDashboardForm, Loading, ModalError } from '@components'
import { validateInputImage } from '@helpers'
import { zodResolver } from '@hookform/resolvers/zod'
import { useErrorModal } from '@hooks'
import { AdminDashboardFormType, adminDashboardFormSchema } from '@schema'
import { axiosService } from '@services'
import { SummaryDashboard } from '@types'
import { FC, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { z } from 'zod'

type AdminDashboardFormWrapperProps = {
  summaryDashboard: SummaryDashboard
  isAllowUpdateStatus: boolean
}

const AdminDashboardFormWrapper: FC<AdminDashboardFormWrapperProps> = ({ summaryDashboard, isAllowUpdateStatus }) => {
  const { isOpen, content, setErrorContent, toggleModal } = useErrorModal()

  const methods = useForm<AdminDashboardFormType>({
    defaultValues: {
      image: summaryDashboard.image,
      boardName: summaryDashboard.name,
      ...(isAllowUpdateStatus && { isActive: summaryDashboard.is_active }),
    },
    mode: 'onSubmit',
    resolver: zodResolver(adminDashboardFormSchema),
    reValidateMode: 'onSubmit',
  })

  const saveDashboardDetail = async (formData: AdminDashboardFormType) => {
    const plantIDs = summaryDashboard?.plants.map(element => {
      return element.plant_id
    }) || [];

    const bodyReq = {
      plant_ids: plantIDs,
      name: formData.boardName,
      image: formData.image,
      ...(isAllowUpdateStatus && { is_active: formData.isActive }),
    };

    const { codeHTTP } = await axiosService({ method: 'put', apiPath: `${API.ADMIN_DASHBOARD}/${summaryDashboard.id}`, data: bodyReq })

    if(codeHTTP === 200) {
      window.location.reload()
    }

  };

  const { isSubmitting } = methods.formState

  const onValidateInputImage = (e) => {
    let file = e.target.files[0]
    if (!e || !file) return

    const result = validateInputImage(e)

    if (result.isError) {
      methods.setValue('image', null)
      setErrorContent(result.errorMessage)
      return
    }

    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = (data) => {
      methods.setValue('image', data.target.result)
    }
  }

  const handleSubmit = methods.handleSubmit(saveDashboardDetail);
  const onClearImage = () => methods.setValue('image', null)

  useEffect(() => {
    methods.reset({
      image: summaryDashboard.image,
      boardName: summaryDashboard.name,
      isActive: summaryDashboard.is_active,
    })
  }, [summaryDashboard, methods])

  return (
    <FormProvider {...methods}>
      {isSubmitting && <Loading />}
      <form>
        <AdminDashboardForm
          summaryDashboard={summaryDashboard}
          isAllowUpdateStatus={isAllowUpdateStatus}
          onClearImage={onClearImage}
          handleSubmit={handleSubmit}
          validateInputImage={onValidateInputImage}
        />
      </form>
      {isOpen && <ModalError isDisplay={isOpen} content={content} closeModal={toggleModal} />}
    </FormProvider>
  )
}

export default AdminDashboardFormWrapper
